import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import Helper from './plugins/helper'
import vuetify from './plugins/vuetify';
import router from './router'
import store from './store'
import VueSocialSharing from 'vue-social-sharing';
import '@/plugins/apexcharts'
import {longClickDirective} from "vue-long-click";

export const serverBus = new Vue();
Vue.config.productionTip = false

const lci = longClickDirective({delay: 1000, interval: 1000})

Vue.use(Helper);
Vue.use(serverBus);
Vue.use(VueSocialSharing);
Vue.directive('long-click', lci);

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')